import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'itl-listitem-header',
  templateUrl: './listitem-header.component.html',
  styleUrls: ['./listitem-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListitemHeaderComponent {}
